/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from '@emotion/core';
import { Checkbox, Input, InputNumber, Modal, Select } from 'antd';
import { ModalTitle } from '~components/_common/ModalTitle/ModalTitle';
import { useIntl } from 'react-intl';
import { Fragment, useRef, useState, useEffect } from 'react';
// Import voucher type icon utility
import { renderVoucherTypeIcon } from '~components/molecules/Tabs/TenderTabs/components/ContractAndOffers/utils';

const { Option } = Select;

const initialFormValues = {
  type: 2, // TERMS_OF_SERVICE | (terms of service)
  cardTitle: '',
  cardSubtitle: '',
  cardQuantity: 0,
  unitType: 1,
  cardPrice: 0,
  cardSum: 0,
  isOptional: false,
};

export const ContractBuilderAddCardModal = ({
  visible,
  onCancel,
  onOk,
  confirmLoading,
  tenderClosed,
}) => {
  const intl = useIntl();

  const cardTypesOptions = [
    {
      label: intl.formatMessage({ id: 'offer-list' }),
      value: 2, //voucher type
    },
    {
      label: intl.formatMessage({ id: 'unit-sum' }),
      value: 1,
    },
    {
      label: intl.formatMessage({ id: 'terms-of-service' }),
      value: 4,
    },
    {
      label: intl.formatMessage({ id: 'upload-certificate' }),
      value: 3,
    },
  ];

  const sumUnitTypes = [
    { value: 1, label: intl.formatMessage({ id: 'centimeter' }) },
    { value: 2, label: intl.formatMessage({ id: 'meter' }) },
    { value: 3, label: intl.formatMessage({ id: 'square-meter' }) },
    { value: 4, label: intl.formatMessage({ id: 'cubic-meter' }) },
    { value: 5, label: intl.formatMessage({ id: 'piece' }) },
    { value: 6, label: intl.formatMessage({ id: 'sum' }) },
    { value: 7, label: intl.formatMessage({ id: 'kilogram' }) },
    { value: 8, label: intl.formatMessage({ id: 'ton' }) },
    { value: 9, label: intl.formatMessage({ id: 'timer' }) },
    { value: 10, label: intl.formatMessage({ id: 'day' }) },
    { value: 11, label: intl.formatMessage({ id: 'week' }) },
    { value: 12, label: intl.formatMessage({ id: 'month' }) },
  ];

  const [formValues, setFormValues] = useState(initialFormValues);
  const nameInputRef = useRef<Input>(null);

  const isValid = () => {
    if (tenderClosed) return false;
    if (!formValues.cardTitle) return false;
    if (!formValues.type) return false;

    return true;
  };

  const handleSubmit = () => {
    onOk(formValues);
  };

  useEffect(() => {
    if (!visible) {
      setFormValues(initialFormValues);
    }
  }, [visible]);

  const getVoucherSpecificForm = (cardType) => {
    if (cardType === 1)
      return (
        <Fragment>
          <InputNumber
            style={{ width: '100%' }}
            placeholder={intl.formatMessage({ id: 'quantity' })}
            onChange={(value) =>
              setFormValues({ ...formValues, cardQuantity: Number(value) })
            }
          />
          <Select
            placeholder={intl.formatMessage({ id: 'select-unit-type' })}
            style={{ width: '100%' }}
            onChange={(value) =>
              setFormValues({ ...formValues, unitType: Number(value) })
            }>
            {sumUnitTypes.map((option) => (
              <Option key={option.value} value={option.value}>
                {option.label}
              </Option>
            ))}
          </Select>
          {/*<InputNumber*/}
          {/* style={{ width: '100%' }}*/}
          {/* placeholder={intl.formatMessage({ id: 'price' })}*/}
          {/* onChange={(value) =>*/}
          {/* setFormValues({ ...formValues, cardPrice: Number(value) })*/}
          {/* }*/}
          {/*/>*/}
          {/*<InputNumber*/}
          {/* style={{ width: '100%' }}*/}
          {/* placeholder={intl.formatMessage({ id: 'sum' })}*/}
          {/* onChange={(value) =>*/}
          {/* setFormValues({ ...formValues, cardSum: Number(value) })*/}
          {/* }*/}
          {/*/>*/}
        </Fragment>
      );
    if (cardType === 2) return <p></p>;
    if (cardType === 3) return <p></p>;
    if (cardType === 4) return <p></p>;
  };

  return (
    <Modal
      title={
        <ModalTitle
          text={intl.formatMessage({ id: 'add-card' })}
          icon={['far', 'ticket']}
        />
      }
      okText={intl.formatMessage({ id: 'add' })}
      cancelText={intl.formatMessage({ id: 'cancel' })}
      width={800}
      centered
      visible={visible}
      onOk={handleSubmit}
      confirmLoading={confirmLoading}
      okButtonProps={{ disabled: !isValid() }}
      onCancel={onCancel}
      destroyOnClose>
      <Fragment>
        <div
          css={{
            display: 'flex',
            flexDirection: 'column',
            gap: '20px',
            // background: 'red',
          }}>
          <Input
            ref={nameInputRef}
            placeholder={intl.formatMessage({ id: 'name' })}
            allowClear
            value={formValues.cardTitle}
            onChange={(e) =>
              setFormValues({ ...formValues, cardTitle: e.target.value })
            }
          />
          <Input.TextArea
            placeholder={intl.formatMessage({ id: 'description' })}
            allowClear
            value={formValues.cardSubtitle}
            autoSize={{ minRows: 2, maxRows: 5 }}
            onChange={(e) =>
              setFormValues({ ...formValues, cardSubtitle: e.target.value })
            }
          />
          <div>
            <Select
              css={{ width: '100%' }}
              onChange={(value) =>
                setFormValues({ ...formValues, type: value })
              }
              placeholder={intl.formatMessage({ id: 'voucher-type' })}
              value={formValues.type}>
              {cardTypesOptions.map((option) => (
                <Option key={option.value} value={option.value}>
                  {/* Flex wrapper for icon and label in dropdown */}
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: '10px',
                    }}>
                    {renderVoucherTypeIcon(option.value, intl)}
                    <span>{option.label}</span>
                  </div>
                </Option>
              ))}
            </Select>
          </div>

          <div
            css={{
              display: 'flex',
              flexDirection: 'column',
              gap: '4px',
            }}>
            <Checkbox
              checked={formValues.isOptional}
              onChange={(e) =>
                setFormValues({
                  ...formValues,
                  isOptional: e.target.checked,
                })
              }>
              {intl.formatMessage({ id: 'optional-voucher' })}
            </Checkbox>

            <span
              css={{
                color: '#7a7a7a',
                fontSize: '12px',
                lineHeight: '18px',
                paddingLeft: '24px',
              }}>
              {intl.formatMessage({ id: 'optional-voucher-description' })}
            </span>
          </div>

          {getVoucherSpecificForm(formValues.type)}
        </div>
      </Fragment>
    </Modal>
  );
};
